export default __webpack_public_path__ + "static/media/line-bg2.cfded2fd.png";